import { observable, action } from "mobx";
import axios from "axios";

export default class AppStore {
    //general
    @observable width;
    @observable gridMode;
    @observable innerHeight;

    //sidebar
    @observable sidebarFechado;
    @observable expandirGrupoSidebar;

    @observable baseUrl;
    @observable contentBackgroundWhite;

    @observable currentPage;


    constructor() {
        this.sidebarFechado = false;
        this.expandirGrupoSidebar = "Ações pendentes";
        this.width = window.innerWidth;
        this.innerHeight = window.innerHeight;
        this.gridMode = false;
        this.baseUrl = "https://localhost:8433/api"
        this.contentBackgroundWhite = false;
        this.currentPage = null;
    }

    toggleSideBar() {
        this.sidebarFechado = !this.sidebarFechado;
    }

    setCurrentPage(page) {
        this.currentPage = page;
    }

    toggleSideBarGroup(group) {
        if(group === this.expandirGrupoSidebar)
            this.expandirGrupoSidebar = "none";
        else
            this.expandirGrupoSidebar = group;
    }

    @action authenticate() {
        return new Promise((resolve, reject) => {
            this.authenticating = true;
            setTimeout(() => {
                this.authenticated = !this.authenticated;
                this.authenticating = false;
                resolve(this.authenticated);
            }, 0);
        });
    }
}
